var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fire"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M58.53,113.81s-23.73.72-33.8-13.67c-7.6-10.86-2.15-30.92-2.15-30.92S34.8,82.88,37,75s-3.42-13.17-.72-28C39.12,31.1,61.41,16,61.41,16s-5,5,13.67,25.17C81.46,48,77.23,62,77.23,62S85.86,59.15,88,46.92c13,11.51,9.35,30.93,9.35,30.93s6.47-5,7.19-10.07c.72.72,18,15.1-7.19,37.4-12.23,6.47-15.1,7.91-27.33,8.63,19.42-15.11,9.35-35.24,9.35-35.24s-2.88,11.5-12.94,15.82c2.87-21.58-7.2-31.64-7.2-31.64s-11.5,8.63-11.5,23S58.53,113.81,58.53,113.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.65b9598014f8b8025cf7d5a36f6088f6.svg";
export { ForwardRef as ReactComponent };